<template>
    <div>
        <el-dialog title="市场咨询补充协议" :visible.sync="jcxy" :close-on-click-modal="false" width="800px" center>
            <el-form :inline="true">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="签署公司（乙方）">
                            <el-select v-model="reqCreate.signSealId" style="width:500px" @change="selectJms" clearable
                                placeholder="请选择" filterable>
                                <el-option v-for="(item, index) in allJMSList" :key="index" :label="item.companyName"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系电话（乙方）">
                            <el-input v-model="reqCreate.tel" style="width:240px" clearable maxlength="11" show-word-limit
                                placeholder></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="信用代码（乙方）">
                            <el-input v-model="reqCreate.xinyongdaima" style="width:240px" clearable show-word-limit
                                placeholder></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="联系地址（乙方）">
                            <el-input v-model="reqCreate.address" style="width:623px" show-word-limit placeholder
                                clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row>
                    <el-col :span="24">
                        <el-form-item label="签署公司（丙方）">
                            <el-select v-model="reqCreate.signSealIdBing" style="width:500px" @change="selectJmsBing"
                                clearable placeholder="请选择" filterable>
                                <el-option v-for="(item, index) in allJMSList" :key="index" :label="item.companyName"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系电话（丙方）">
                            <el-input v-model="reqCreate.b_tel" style="width:240px" clearable maxlength="11" show-word-limit
                                placeholder></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="信用代码（丙方）">
                            <el-input v-model="reqCreate.b_xinyongdaima" style="width:240px" clearable show-word-limit
                                placeholder></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="联系地址（丙方）">
                            <el-input v-model="reqCreate.b_address" style="width:623px" show-word-limit placeholder
                                clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row>
                    <el-form-item label="《市场咨询服务合同》日期">
                        <el-date-picker v-model="reqCreate.q_date" type="datetime" placeholder="选择日期"
                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="(丙发票信息)名称">
                        <el-input v-model="reqCreate.b_name" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号">
                        <el-input v-model="reqCreate.b_nasui" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>
                    <el-form-item label="地址、电话">
                        <el-input v-model="reqCreate.b_dizhidianhua" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>
                    <el-form-item label="开户行及账号">
                        <el-input v-model="reqCreate.b_khhzh" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>

                    <el-form-item label="(丙方联系方式)联系人">
                        <el-input v-model="reqCreate.b_lianxi" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>
                    <el-form-item label="地址">
                        <el-input v-model="reqCreate.b_dizhi" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>
                    <el-form-item label="手机">
                        <el-input v-model="reqCreate.b_shouji" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>
                    <el-form-item label="微信">
                        <el-input v-model="reqCreate.b_weixin" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱">
                        <el-input v-model="reqCreate.b_dzyj" style="width:240px" clearable show-word-limit
                            placeholder></el-input>
                    </el-form-item>

                </el-row>

                <el-row>
                    <el-form-item label="合同日期" prop="data1">
                        <el-date-picker v-model="reqCreate.htrq" type="datetime" placeholder="选择日期"
                            value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>

                </el-row>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy = false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
        </el-dialog>

        <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
            <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0"
                style="width:870px;height:800px"></iframe>

            <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import wmsApi from "@/script/api/wmsApi";
import globalData from '@/components/common/globaldata/global.data';
export default {
    data() {
        return {
            id: null,
            jcxy: false,
            PDFVisible: false,
            contractUrl: null,
            allJMSList: [],

            addField: {},
            singList: [],
            choosePerson: {}, //下拉框所选人
            chooseBing: {},
            reqCreate: {
                xinyongdaima: '',
                htrq: '',
                address: "",
                fraId: '',
                tel: "",
                templateNo: "",
                type: '',
                signSealId: '',
                signSealIdBing: '',
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "state": '',

                b_fraName: '',
                b_xinyongdaima: '',
                b_address: '',
                b_tel: '',

                b_name: '',
                b_nasui: '',
                b_dizhidianhua: '',
                b_khhzh: '',
                b_lianxi: '',
                b_dizhi: '',
                b_shouji: '',
                b_weixin: '',
                b_dzyj: '',


                s_date: '',



            },
          city:'',
        };
    },
    methods: {
        showDetail(city) {
            this.getAllJMS();
            this.jcxy = true;
            this.city=city;
            this.reqCreate = {
                xinyongdaima: '',
                htrq: '',
                address: "",
                fraId: '',
                tel: "",
                templateNo: "",
                type: '',
                signSealId: '',
                signSealIdBing: '',
                "contractNo": "",
                "createTime": "",
                "createUserId": '',
                "createUserName": "",
                "fraName": "",
                "id": '',
                "idCard": "",
                "jsonData": "",
                "processId": "",
                "remark": "",
                "signName": "",
                "state": '',

                b_fraName: '',
                b_xinyongdaima: '',
                b_address: '',
                b_tel: '',

                b_name: '',
                b_nasui: '',
                b_dizhidianhua: '',
                b_khhzh: '',
                b_lianxi: '',
                b_dizhi: '',
                b_shouji: '',
                b_weixin: '',
                b_dzyj: '',

                s_date: '',


            };

        },
        selectJmsBing(id) {
            if (id == null || id == '') {
                this.chooseBing = {};
                // this.reqCreate.fraId = "";
                this.reqCreate.b_xinyongdaima = "";
                this.reqCreate.b_tel = "";
                this.reqCreate.b_address = "";
            }
            if (id != null) {
                let ren = {};
                this.allJMSList.forEach(e => {
                    if (e.id == id) {
                        ren = e;
                    }
                })
                this.chooseBing = ren;
                // this.reqCreate.fraId = ren.franchiseeId;
                this.reqCreate.b_xinyongdaima = ren.creditCode;
                this.reqCreate.b_tel = ren.tel;
                this.reqCreate.b_address = ren.address;
            }
        },
        selectJms(id) {
            if (id == null || id == '') {
                this.choosePerson = {};
                this.reqCreate.fraId = "";
                this.reqCreate.xinyongdaima = "";
                this.reqCreate.tel = "";
                this.reqCreate.address = "";
            }
            if (id != null) {
                let ren = {};
                this.allJMSList.forEach(e => {
                    if (e.id == id) {
                        ren = e;
                    }
                })
                this.choosePerson = ren;
                this.reqCreate.fraId = ren.franchiseeId;
                this.reqCreate.xinyongdaima = ren.creditCode;
                this.reqCreate.tel = ren.tel;
                console.log(ren);
                this.reqCreate.address = ren.address;
            }
        },
        checkFm() {

            if (this.reqCreate.signSealId == null || this.reqCreate.signSealId == '') {
                this.$message.error('请选择（乙方）签署公司');
                return false;
            }
            if (this.reqCreate.tel == null || this.reqCreate.tel == '' || this.reqCreate.tel.length != 11) {
                this.$message.error('请输入（乙方）联电话，或输入正确的电话号码');
                return false;
            }
            if (this.reqCreate.xinyongdaima == null || this.reqCreate.xinyongdaima == '') {
                this.$message.error('请输入（乙方）信用代码');
                return false;
            }

            if (this.reqCreate.address == null || this.reqCreate.address == '') {
                this.$message.error('请输入（乙方）联系地址');
                return false;
            }

            if (this.reqCreate.signSealIdBing == null || this.reqCreate.signSealIdBing == '') {
                this.$message.error('请选择（丙方）签署公司');
                return false;
            }
            if (this.reqCreate.b_tel == null || this.reqCreate.b_tel == '' || this.reqCreate.b_tel.length != 11) {
                this.$message.error('请输入（丙方）联电话，或输入正确的电话号码');
                return false;
            }
            if (this.reqCreate.b_xinyongdaima == null || this.reqCreate.b_xinyongdaima == '') {
                this.$message.error('请输入（丙方）信用代码');
                return false;
            }

            if (this.reqCreate.b_address == null || this.reqCreate.b_address == '') {
                this.$message.error('请输入（丙方）联系地址');
                return false;
            }

            if (this.reqCreate.q_date == null || this.reqCreate.q_date == '') {
                this.$message.error('请选择《市场咨询服务合同》日期');
                return false;
            }

            if (this.reqCreate.htrq == null || this.reqCreate.htrq == '') {
                this.$message.error('请选择合同日期');
                return false;
            }

            return true;
        },
        fillTemplate() {
            let addField = {
                fraName: this.choosePerson.companyName,
                xinyongdaima: this.reqCreate.xinyongdaima,
                address: this.reqCreate.address,
                tel: this.reqCreate.tel,

                b_fraName: this.chooseBing.companyName,
                b_xinyongdaima: this.reqCreate.b_xinyongdaima,
                b_address: this.reqCreate.b_address,
                b_tel: this.reqCreate.b_tel,

                b_name: this.reqCreate.b_name,
                b_nasui: this.reqCreate.b_nasui,
                b_dizhidianhua: this.reqCreate.b_dizhidianhua,
                b_khhzh: this.reqCreate.b_khhzh,
                b_lianxi: this.reqCreate.b_lianxi,
                b_dizhi: this.reqCreate.b_dizhi,
                b_shouji: this.reqCreate.b_shouji,
                b_weixin: this.reqCreate.b_weixin,
                b_dzyj: this.reqCreate.b_dzyj,


                q_year: this.reqCreate.q_date.substring(0, 4),
                q_month: this.reqCreate.q_date.substring(5, 7) * 1,
                q_day: this.reqCreate.q_date.substring(8, 10) * 1,

                s_year: this.reqCreate.htrq.substring(0, 4),
                s_month: this.reqCreate.htrq.substring(5, 7) * 1,
                s_day: this.reqCreate.htrq.substring(8, 10) * 1,

                jia: '',
                yi: '',
                bing:'',
                Contract_no: ''
            };
            this.addField = addField;
            return addField;
        },
        yulan() {
            if (!this.checkFm()) {
                return;
            }
            let temFields = this.fillTemplate();
            this.reqCreate.tempSignData = temFields;
            let eventType=206;
            if(this.city=='苏州'){
              eventType=206
            }else if(this.city=='杭州'){
              eventType=210
            }else if(this.city=='宅景'){
              eventType=220
            }
            let reqData = {
                // cityId: this.reqCreate.cityId,
                fraId: this.reqCreate.fraId,
                eventType: eventType,
                name: '市场咨询补充协议',
                simpleFormFields: temFields
            };

            const loading = this.$loading({
                lock: true,
                text: '努力生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            contract
                .$ajaxPreviewFile(reqData)
                .then((res) => {
                    if (res.data.errno == 0) {
                        loading.close();
                        // console.log(res);
                        this.contractUrl = res.data.data.downloadUrl;
                        this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
                        this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
                        this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
                        this.PDFVisible = true;
                    } else {
                        loading.close();
                        this.$message({
                            showClose: true,
                            message: res.data.data,
                            type: 'warning',
                            duration: 8000
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        sendContractBtn() {
            const loading = this.$loading({
                lock: true,
                text: '发送合同中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });

            this.reqCreate.fraId = globalData.franchisee.id;
            this.reqCreate.createUserId = this.reqCreate.fraId;// globalData.userInfo.id;
            this.reqCreate.createUserName = globalData.userInfo.userName;
            //this.reqCreate.type = 206;
            if(this.city=='苏州'){
              this.reqCreate.type = 206;
            }else if(this.city=='杭州'){
              this.reqCreate.type=210
            }else if(this.city=='宅景'){
              this.reqCreate.type=220
            }

            contract.$ajaxJmsSignContract(this.reqCreate).then((res) => {
                loading.close();
                if (res.data.errno == 0) {
                    this.$message.success('合同已发送！');
                    // this.querySearch();
                    this.$emit('querySearch');
                    this.PDFVisible = false;
                    this.jcxy = false;
                } else {
                    this.$message.warning(res.data.data);
                }
            });
        },
        getAllJMS() {
            //城市下拉框
            contract
                .$ajaxJmsgetJMSAll()
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.allJMSList = res.data.data;
                    }
                });
        },
    }
};
</script>
<style lang="">
</style>
